// extracted by mini-css-extract-plugin
export default {"deliveryProvider":"DeliveryProviderLabel-module__deliveryProvider___4lEp6"};